// getBundleSimilars.ts
import { api } from '../core';
import { BUNDLE_SIMILARS_TAG } from '../constants';
import { ServerBundleType } from '../types';

export interface BundleSimilarItem {
  bundleType: ServerBundleType;
  categoryName: string;
  documentName: string;
  similarityGroupId: string;
  pageId: string;
  pageNumber: number;
  providerName: string;
}

export type BundleSimilarsResponse = BundleSimilarItem[];

type GetBundleSimilarsProps = {
  bundleId: string;
  abortController?: AbortController;
};

const getBundleSimilarsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBundleSimilars: builder.query<BundleSimilarsResponse, GetBundleSimilarsProps>({
      query: ({ bundleId, abortController = new AbortController() }: GetBundleSimilarsProps) => ({
        url: 'bundle/similar',
        method: 'GET',
        params: {
          bundleId: bundleId,
        },
        signal: abortController.signal,
      }),
      providesTags: (_result, _err, { bundleId }) => [{ type: BUNDLE_SIMILARS_TAG, id: bundleId }],
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetBundleSimilarsQuery } = getBundleSimilarsApi;
